'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { ChevronDown } from '@/components/icons/ChevronDown';
import { FeatureCard } from '@/components/page-builder/global/featureRoadmap/FeatureCard';
import { useCollapsibleCategories } from '@/components/page-builder/global/featureRoadmap/useCollapsibleCategories';
import Heading from '@/components/typography/Heading';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { cn } from '@/lib/styles';
type FeatureRoadmapMobileProps = {
  readonly categories: Data.Component<'shared.roadmap-category'>[];
  readonly column: 'primary' | 'secondary';
};
export function FeatureRoadmapMobile(t0) {
  const $ = _c(11);
  const {
    categories,
    column
  } = t0;
  const {
    openCategories,
    toggleCategory
  } = useCollapsibleCategories(categories);
  let t1;
  if ($[0] !== categories || $[1] !== column || $[2] !== openCategories || $[3] !== toggleCategory) {
    let t2;
    if ($[5] !== column || $[6] !== openCategories || $[7] !== toggleCategory) {
      t2 = category => {
        if (!category || !category.id) {
          return null;
        }
        const categoryId = category.id;
        const isOpen = openCategories[categoryId] ?? false;
        const items = column === "primary" ? category.primaryColumnItems : category.secondaryColumnItems;
        if (!items || items.length === 0) {
          return null;
        }
        return <Collapsible key={categoryId} open={isOpen} onOpenChange={() => toggleCategory(categoryId)} className="w-full"><CollapsibleTrigger className="group inline-flex items-center gap-2 cursor-pointer py-2.5 px-4 hover:opacity-70 transition-opacity"><Heading tag="h2" fontSize="headingMedium">{category.title}</Heading><ChevronDown className={cn("size-5 transition-transform duration-200", isOpen && "rotate-180")} /></CollapsibleTrigger><CollapsibleContent><div className="flex flex-col gap-5 px-4 pt-5">{items.map(item => {
                if (!item) {
                  return null;
                }
                return <FeatureCard key={item.id} item={item} variant={column === "secondary" ? "secondary" : "primary"} />;
              })}</div></CollapsibleContent></Collapsible>;
      };
      $[5] = column;
      $[6] = openCategories;
      $[7] = toggleCategory;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = categories.map(t2);
    $[0] = categories;
    $[1] = column;
    $[2] = openCategories;
    $[3] = toggleCategory;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="bg-white rounded-xl"><div className="flex flex-col gap-15">{t1}</div></div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}